/**
 * Canonical DP financial totals — single source of truth.
 *
 * Matches the formula used by the DP list, PDF, Excel export, and modal.
 * All call sites must route through this helper; do NOT duplicate the math inline.
 *
 * @param {number} subtotal       - SUM(payment_values.monthly_amount) for the DP
 * @param {number} retentionRate  - holdback % as a whole number (e.g. 10 = 10%), default 10
 * @param {number} tpsRate        - TPS % as a whole number (e.g. 5 = 5%), default 5
 * @param {number} tvqRate        - TVQ % as a whole number (e.g. 9.975 = 9.975%), default 9.975
 * @returns {{ subtotal, retention, avantTaxes, tps, tvq, totalAvecTaxes }}
 */
export function computeDpTotals(subtotal, retentionRate = 10, tpsRate = 5, tvqRate = 9.975) {
  const sub  = Number(subtotal);  const st  = Number.isFinite(sub)  ? sub  : 0;
  const rr   = Number(retentionRate); const R   = Number.isFinite(rr)   ? rr   : 10;
  const tpsR = Number(tpsRate);   const TPS = Number.isFinite(tpsR)  ? tpsR : 5;
  const tvqR = Number(tvqRate);   const TVQ = Number.isFinite(tvqR)  ? tvqR : 9.975;

  const retention      = st * R / 100;
  const avantTaxes     = st - retention;
  const tps            = avantTaxes * TPS / 100;
  const tvq            = avantTaxes * TVQ / 100;
  const totalAvecTaxes = avantTaxes + tps + tvq;

  return { subtotal: st, retention, avantTaxes, tps, tvq, totalAvecTaxes };
}
